import { yup } from '@guiker/yup-util'

export const userIdNested = yup.object({
  userId: yup.string().required(),
})

export type UserIdNested = yup.InferType<typeof userIdNested>
